import {
  Partners,
  PolicyStatus,
  Role,
  RoleType,
} from '@lockton-apps/shared/interfaces';
import { createDefinition } from '@lockton-apps/shared/util/helpers';
import { WorkflowStatusMeta } from './interface';

const getBrokerPolicyStatusMetaDef = createDefinition<WorkflowStatusMeta>({
  base: {
    label: $localize`Active`,
    icon: 'tick',
    level: 'success',
  },
  variants: {
    [PolicyStatus.Active]: {
      base: {
        label: $localize`Active`,
        icon: 'tick',
        level: 'success',
      },
    },
    [PolicyStatus.Inactive]: {
      base: {
        label: $localize`Not bound`,
        icon: 'more',
        level: 'warning',
      },
    },
    [PolicyStatus.Mta]: {
      base: {
        label: $localize`Adjustments`,
        icon: 'edit',
        level: 'info',
      },
    },
    [PolicyStatus.Pending]: {
      base: {
        label: $localize`Not bound`,
        icon: 'more',
        level: 'info',
      },
      variants: {
        [Partners.NORWAY]: {
          base: {
            label: $localize`Health evaluation required`,
            icon: 'health_evaluation_thin',
            level: 'info',
          },
        },
      },
    },
    [PolicyStatus.Expired]: {
      base: {
        label: $localize`Expired`,
        icon: 'exclaim',
        level: 'error',
      },
    },
    [PolicyStatus.Cancelled]: {
      base: {
        label: $localize`Cancelled`,
        icon: 'delete',
        level: 'error',
      },
    },
    [PolicyStatus.Defunct]: {
      base: {
        label: 'Defunct',
        icon: 'delete',
        level: 'error',
      },
    },
    [PolicyStatus.Initialized]: {
      base: {
        label: 'Initialized',
        icon: 'help',
        level: 'info',
      },
    },
  },
});

const getContactPolicyStatusMetaDef = createDefinition<WorkflowStatusMeta>({
  base: {
    label: $localize`Active`,
    icon: 'tick',
    level: 'success',
  },
  variants: {
    [PolicyStatus.Active]: {
      base: {
        label: $localize`Active`,
        icon: 'tick',
        level: 'success',
      },
    },
    [PolicyStatus.Inactive]: {
      base: {
        label: $localize`Not bound`,
        icon: 'more',
        level: 'warning',
      },
    },
    [PolicyStatus.Mta]: {
      base: {
        label: $localize`Adjustments`,
        icon: 'edit',
        level: 'info',
      },
    },
    [PolicyStatus.Pending]: {
      base: {
        label: $localize`Not bound`,
        icon: 'more',
        level: 'info',
      },
      variants: {
        [Partners.NORWAY]: {
          base: {
            label: $localize`Health evaluation required`,
            icon: 'health_evaluation_thin',
            level: 'info',
          },
        },
      },
    },
    [PolicyStatus.Expired]: {
      base: {
        label: $localize`Expired`,
        icon: 'exclaim',
        level: 'error',
      },
    },
    [PolicyStatus.Cancelled]: {
      base: {
        label: $localize`Cancelled`,
        icon: 'delete',
        level: 'error',
      },
    },
    [PolicyStatus.Defunct]: {
      base: {
        label: 'Defunct',
        icon: 'delete',
        level: 'error',
      },
    },
    [PolicyStatus.Initialized]: {
      base: {
        label: 'Initialized',
        icon: 'help',
        level: 'info',
      },
    },
  },
});

// const partnerBrokerPolicyStatusMeta: Partial<
//   Record<Partners | 'DEFAULT', PolicyStatusConfigOverride>
// > = {
//   DEFAULT: {},
//   [Partners.NORWAY]: {
//     [PolicyStatus.Pending]: {
//       DEFAULT: {
//         label: $localize`Health evaluation required`,
//         icon: 'health_evaluation_thin',
//         level: 'info',
//       },
//     },
//   },
// };

// const partnerContactPolicyStatusMeta: Partial<
//   Record<Partners | 'DEFAULT', PolicyStatusConfigOverride>
// > = {
//   DEFAULT: {},
//   [Partners.NORWAY]: {
//     [PolicyStatus.Pending]: {
//       DEFAULT: {
//         label: $localize`Health evaluation required`,
//         icon: 'health_evaluation_thin',
//         level: 'info',
//       },
//     },
//   },
// };

export function getPolicyStatusMeta(
  status: PolicyStatus,
  partner: Partners | 'DEFAULT' = 'DEFAULT',
  role: RoleType | null = Role.Broker
) {
  // const partnerDef =
  //   role === Role.Contact
  //     ? partnerContactPolicyStatusMeta
  //     : partnerBrokerPolicyStatusMeta;
  // const def =
  //   role === Role.Contact ? contactPolicyStatusMeta : brokerPolicyStatusMeta;

  // return getExtendableConfig(def, partnerDef, status, 'DEFAULT', partner);
  return role === Role.Contact
    ? getContactPolicyStatusMetaDef([status, partner])
    : getBrokerPolicyStatusMetaDef([status, partner]);
}
